import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { EstateSection } from '@/components/landing/estate-section'
import { ViewingSection } from '@/components/landing/viewing-section'
import { PathwaysSection } from '@/components/landing/pathways-section'
import { LocationSection } from '@/components/landing/location-section'
import { LifestyleSection } from '@/components/landing/lifestyle-section'
import { ResidencesSection } from '@/components/landing/residences-section'

/*
   Public landing page, in reading order:
   hero, the buyer and resident split, the estate story, the residences
   (spec cards and feature stories), right-sized living for down-scalers,
   the neighbourhood, and the private viewing form.
*/
const Home: FC = (): ReactNode => {
    return (
        <Layout overHero>
            <Seo />

            <HeroSection />
            <PathwaysSection />
            <EstateSection />
            <ResidencesSection />
            <LifestyleSection />
            <LocationSection />
            <ViewingSection />
        </Layout>
    )
}

export default Home
